<div class="flex flex-col px-6 pt-6 gap-3">
  <div class="flex items-center justify-between">
    <h1 class="ml-10 headline-small text-primary flex-1 text-center">{{ headerLabelKey | translate }}</h1>
    <button mat-icon-button
      appDialogClose
      [attr.aria-label]="'Close' | translate">
      <mat-icon class="text-on-surface-variant">close</mat-icon>
    </button>
  </div>
  @if (!isVisitSelectionEnabled) {
    <div class="flex justify-center">
      <p class="body-medium text-on-surface-variant text-center w-[462px]">{{ 'Use T-Pro to ambiently listen and summarise your patient consultations, team meetings, observations, and more.' | translate }} </p><s></s>
    </div>
  }
</div>

<div class="px-6 pt-6">
  <app-patient-selector
    [selectable]="false"
    [visitFlow]="isVisitSelectionEnabled"
    (patientSourceSelected)="selectPatientSource($event)"
    (patientSelected)="selectPatient($event)"></app-patient-selector>
</div>

<div class="px-6 pb-6">
  @if (isVisitSelectionEnabled) {
    <div class="flex flex-col-reverse md:flex-row items-center gap-2 md:gap-3 pt-6 w-full">
      <button mat-stroked-button color="primary" class="h-12 rounded-[8px] max-md:w-full" (click)="openAddPatient()"
        data-testid="start-encounter-manual-button">{{ 'Add patient manually' | translate }}</button>
      <button mat-stroked-button color="primary" class="h-12 rounded-[8px] max-md:w-full" [disabled]="isSubmitting"
        (click)="createAndUpdate()"
        data-testid="start-encounter-without-patient-button">{{ 'Start without patient' | translate }}</button>
      <button mat-flat-button color="primary" class="h-12 rounded-[8px] ml-auto max-md:w-full" [disabled]="!selectedPatient || isSubmitting"
        (click)="onContinue()" data-testid="start-encounter-continue-button">{{ 'Continue' | translate }}</button>
    </div>
  } @else {
    <div class="flex flex-col gap-4 pt-6 w-full">
      <button mat-flat-button color="primary" class="w-full h-12" [disabled]="isSubmitting"
        (click)="createAndUpdate()">{{ 'Start without patient' | translate }}</button>
      <button mat-button class="title-medium text-primary" (click)="openAddPatient()">{{ 'Add patient manually' | translate }}</button>
    </div>
  }
</div>